export default "__VITE_ASSET__BF82rpb$__"